<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="close()">

  <br>
    @if (office) {
      <div>
        {{ 'selectAdminToAssign' | translate }} {{ office.name }}:
      </div>
    }
    <br>

      @if (form) {
        <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
          <div class="text--left">
            <small>
              {{ 'usersNotShown' | translate }}
            </small>
          </div>
          <br>
            <app-input-wrapper
              [control]="form.get('user')"
              label="{{ 'user' | translate }}"
              identifier="user">
              <input
                type="text"
                id="user"
                class="form_control"
                formControlName="user"
                [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" class="dropdown dropdown--autocomplete">
                  @for (user of displayedUsers; track user.id) {
                    <mat-option
                      [value]="user.first_name + ' ' + user.last_name"
                      (onSelectionChange)="onSelectUser(user)">
                      {{ user.first_name + ' ' + user.last_name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </app-input-wrapper>
              <br>
                <button class="button button--primary form_button" type="submit" [disabled]="!form.valid || !form.dirty || !selectedUser">
                  <span class="regular">{{ 'done' | translate }}</span>
                </button>
              </form>
            }

          </app-center-container>

          @if (isLoading) {
            <app-loader></app-loader>
          }